<template>
  <div class="container-fluid">
    <div class="row">
      <div class="d-none d-md-block col-3 pt-5 register-banner">
        <div class="text-md-center mt-5 text-white" style="font-size: 24px">
          Comienza a <b>practicar</b> tus <b>habilidades</b> en
          <b>matemáticas</b> ahora
        </div>
      </div>

      <div class="col p-4">
        <p class="text-black-50 text-right">
          ¿Ya tienes cuenta?
          <router-link to="/login" class="text-dark">Ingresa</router-link>
        </p>

        <div
          v-if="!postRegister"
          class="text-center py-4"
          style="max-width: 376px; margin: auto"
        >
          <MobiusLogo to="/home" />

          <h1 class="text-dark font-h3 mt-5">Regístrate para practicar</h1>

          <!-- Social login -->
          <button ref="googleLoginButton" @click="googleLoginV2()" class="btn btn-social w-100 mt-4">
            <svg
              width="18"
              height="18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.58 9.168c0-.737-.06-1.275-.19-1.834H8.969v3.329h4.943c-.1.827-.638 2.073-1.834 2.91l-.016.111 2.662 2.063.184.018c1.695-1.564 2.671-3.866 2.671-6.597z"
                fill="#4285F4"
              />
              <path
                d="M8.97 17.938c2.42 0 4.454-.797 5.939-2.172l-2.83-2.193c-.758.528-1.774.897-3.11.897-2.372 0-4.385-1.564-5.102-3.727l-.105.01-2.769 2.142-.036.1a8.963 8.963 0 008.012 4.943z"
                fill="#34A853"
              />
              <path
                d="M3.867 10.743a5.522 5.522 0 01-.3-1.774c0-.618.11-1.216.29-1.774l-.005-.119L1.048 4.9l-.091.044A8.977 8.977 0 000 8.969c0 1.445.349 2.81.957 4.026l2.91-2.252z"
                fill="#FBBC05"
              />
              <path
                d="M8.97 3.468c1.683 0 2.82.728 3.467 1.335l2.532-2.471C13.414.887 11.39 0 8.969 0A8.963 8.963 0 00.957 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727z"
                fill="#EB4335"
              />
            </svg>
            Iniciar sesión con Google
          </button>

          <!-- End Social login -->

          <span class="d-block text-center mt-4 mb-3 text-black-50">
            O créala con
          </span>

          <!-- Login form -->
          <form>
            <div class="form-group">
              <label for="name">Nombre</label>
              <input type="text" v-model="registerInfo.name" id="name" class="form-control"/>
              <small v-if="formErrorMessage.name" class="error-hint">
                {{ formErrorMessage.name }}
              </small>
            </div>
            <div class="form-group">
              <label for="email">Correo</label>
              <input type="text" v-model="registerInfo.email" id="email" class="form-control"/>
              <small v-if="formErrorMessage.email" class="error-hint">
                {{ formErrorMessage.email }}
              </small>
            </div>
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input type="password" v-model="registerInfo.password" id="password" class="form-control"/>
              <small v-if="formErrorMessage.password" class="error-hint">
                {{ formErrorMessage.password }}
              </small>
              <small v-if="formErrorMessage.passwordValidation" class="error-hint">
                {{ formErrorMessage.passwordValidation }}
              </small>
            </div>
            <div class="form-group">
              <label for="passwordRepeat">Repita la Contraseña</label>
              <input type="password" v-model="registerInfo.passwordRepeat" id="passwordRepeat" class="form-control"/>
              <small v-if="formErrorMessage.passwordRepeat" class="error-hint">
                {{ formErrorMessage.passwordRepeat }}
              </small>
            </div>
            <button class="btn btn-primary w-100" @click.prevent="register()">
              Crear cuenta
            </button>
            <p class="mt-3 text-tertiary">
              <small
                >Crear una cuenta en Mobius, significa que está de acuerdo con
                nuestras <router-link to="/terms-and-conditions">Condiciones de Servicio</router-link>, y
                <router-link to="/terms-and-conditions">Política de Privacidad</router-link>.</small
              >
            </p>
          </form>
          <!-- End Login form -->
        </div>

        <div
          v-else
          class="m-auto mt-4 p-4 text-center"
          style="max-width: 500px"
        >
          <IconifyIcon :icon="icons.bxEnvelope" height="32" />
          <h2 class="h4 mt-4">
            Hemos enviado un correo de verficación al email que usaste para
            registrarte
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IconifyIcon from "@iconify/vue";
import bxEnvelope from "@iconify/icons-bx/bx-envelope";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "Register",
  components: { IconifyIcon, MobiusLogo },
  data() {
    return {
      registerInfo: {
        name: "",
        email: "",
        password: "",
        passwordRepeat: "",
      },
      formErrorMessage: {
        name: null,
        email: null,
        password: null,
        passwordRepeat: null,
        passwordValidation: null
      },
      postRegister: false,
      icons: {
        bxEnvelope,
      },
    };
  },
  methods: {
    facebookLoginV2() {
      window.location.href = import.meta.env.VITE_FACEBOOK_AUTH_URL;
    },
    googleLoginV2() {
      window.location.href = import.meta.env.VITE_GOOGLE_AUTH_URL;
    },
    register() {
      if (this.validateRegisterInfo()) {
        let loader = this.$loading.show({});
        axios
          .post(
            `${import.meta.env.VITE_API_BASE_URL}/auth/signup`, this.registerInfo
          )
          .then((apiResponse) => {
            loader.hide();
            if (apiResponse.status === 201) {
              this.postRegister = true;
            }
          })
          .catch((error) => {
            loader.hide();
            const apiMessage = error.response?.data?.message;
            this.$toasted.error(
              apiMessage || "El correo ya existe, verifique que no haya una cuenta con ese correo o que no sea su correo personal de una cuenta de Facebook o Gmail existente dentro de la plataforma.",
              { position: "top-center", duration: 10000 }
            );
            error.response?.data?.name
              ? (this.formErrorMessage.name = error.response.data.name.join(
                  " "
                ))
              : null;
            error.response?.data?.email
              ? (this.formErrorMessage.email = error.response.data.email.join(
                  " "
                ))
              : null;
            error.response?.data?.password
              ? (this.formErrorMessage.password = error.response.data.password.join(
                  " "
                ))
              : null;
            error.response?.data?.passwordRepeat
              ? (this.formErrorMessage.passwordRepeat = error.response.data.passwordRepeat.join(
              " "
              ))
              : null;
          });
      }
    },
    validateRegisterInfo() {
      let errorCount = 0;

      if (!this.registerInfo.name) {
        this.formErrorMessage.name = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.name = null;
      }
      if (!this.registerInfo.email) {
        this.formErrorMessage.email = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.email = null;
      }
      if (!this.registerInfo.password) {
        this.formErrorMessage.password = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.password = null;
      }
      if (!this.registerInfo.passwordRepeat) {
        this.formErrorMessage.passwordRepeat = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.passwordRepeat = null;
      }
      if (this.registerInfo.passwordRepeat && this.registerInfo.password &&
        this.registerInfo.password !== this.registerInfo.passwordRepeat) {
        this.formErrorMessage.passwordValidation = "Las contraseñas no coinciden.";
        errorCount++;
      } else {
        this.formErrorMessage.passwordValidation = null;
      }

      return errorCount === 0;
    },

    goToLogin() {
      // Redirect to login
      this.$router.push("/login");
    },
    mounted() {

    },
  },
};
</script>

<style scoped>
.register-banner {
  background-image: url("../assets/images/register-banner.jpg");
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  max-width: 430px;
}
</style>
